// extracted by mini-css-extract-plugin
export default {"actions":"Preview_actions__F8Lo0","leftPanel":"Preview_leftPanel__87Dla","summary":"Preview_summary__1wSbV"};